import { post } from "../../shared/lib/api"

// Different from uiEventTracker, that it isn't defined before, check it was defined before (used on test env).
const logIFTTTNextAction =
  window.logIFTTTNextAction ||
  ((eventName, params = {}) => {
    Object.assign(params, {
      path: window.location.href,
      referer: window.App.referrer || document.referrer,
    })

    return post(`/log_ifttt_next_event?item=${eventName}`, params)
  })

export default logIFTTTNextAction
